// Convert literal \n strings from CMS to actual line breaks
/** @param {string | undefined} str */
export const processLineBreaks = (str) => str?.replace(/\\n/g, '\n');

/** @param {string | undefined} str */
export const processWhitespaces = (str) => str?.replace(' ', '\u00A0');
